import type { DonationBusinessesApiDto } from '__generated__/api/unauth/types.gen';

import { ROUTES } from '@/constants';

import { SearchDonationCard } from '../DonationBusinessSearch/SearchDonationCard';
import { SearchDonationSkeletonList } from '../DonationBusinessSearch/SearchDonationCardSkeleton';
import { SectionHeader } from './SectionHeader';

const PREVIEW_COUNT = 3;

export function DonationBusinessPreviewSection({
  keyword,
  items,
  totalCount,
  isLoading,
}: {
  keyword: string;
  items: DonationBusinessesApiDto[];
  totalCount: number;
  isLoading: boolean;
}) {
  if (!isLoading && items.length < 1) return null;

  return (
    <section className="flex w-full flex-col">
      <SectionHeader
        title="지정기부사업"
        totalCount={totalCount}
        moreHref={ROUTES.SEARCH.withSearchParams({
          searchParams: {
            q: keyword || undefined,
            category: 'hometown-business',
          },
        })}
      />
      {isLoading ? (
        <SearchDonationSkeletonList count={PREVIEW_COUNT} />
      ) : (
        <ul className="flex flex-col gap-20 mobile-tablet:gap-16 mobile-tablet:px-20">
          {items.map((item) => (
            <li key={item.donationBusinessId}>
              <SearchDonationCard
                businessId={item.donationBusinessId ?? 0}
                thumbnailUrl={item.thumbnailUrl ?? ''}
                title={item.donationBusinessName ?? ''}
                institutionName={item.institutionName ?? ''}
                endDate={item.endDate}
                donationAmount={Math.max(
                  (item.goalAmt ?? 0) - (item.rmAmt ?? 0),
                  0,
                )}
                achievementRate={item.achievementRate ?? 0}
                isEnded={item.specificDonationStatus === 'ENDED'}
              />
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
